import React from "react";
import { FaFacebookF, FaXTwitter, FaLinkedinIn, FaWhatsapp, FaLink } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa";
import { toast } from "sonner";

export const ShareButtons = ({ url, title, dark = false, className = "" }) => {
  const shareUrl = url || (typeof window !== "undefined" ? window.location.origin : "");
  const text = title || "The Love Genome™ by Felicia T. Johnson";
  const eu = encodeURIComponent(shareUrl);
  const et = encodeURIComponent(text);

  const targets = [
    { key: "facebook", label: "Share on Facebook", Icon: FaFacebookF, href: `https://www.facebook.com/sharer/sharer.php?u=${eu}` },
    { key: "x", label: "Share on X", Icon: FaXTwitter, href: `https://twitter.com/intent/tweet?url=${eu}&text=${et}` },
    { key: "linkedin", label: "Share on LinkedIn", Icon: FaLinkedinIn, href: `https://www.linkedin.com/sharing/share-offsite/?url=${eu}` },
    { key: "whatsapp", label: "Share on WhatsApp", Icon: FaWhatsapp, href: `https://wa.me/?text=${et}%20${eu}` },
    { key: "email", label: "Share by Email", Icon: FaEnvelope, href: `mailto:?subject=${et}&body=${et}%20${eu}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Couldn't copy the link");
    }
  };

  const base = dark
    ? "border-white/25 text-cream/80 hover:bg-gold hover:text-ink hover:border-gold"
    : "border-line text-ink/70 hover:bg-emerald hover:text-cream hover:border-emerald";

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="share-buttons">
      {targets.map(({ key, label, Icon, href }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          data-testid={`share-${key}`}
          className={`w-10 h-10 flex items-center justify-center border transition-all duration-300 ${base}`}
        >
          <Icon className="text-sm" />
        </a>
      ))}
      <button
        onClick={copy}
        aria-label="Copy link"
        title="Copy link"
        data-testid="share-copy"
        className={`w-10 h-10 flex items-center justify-center border transition-all duration-300 ${base}`}
      >
        <FaLink className="text-sm" />
      </button>
    </div>
  );
};

export default ShareButtons;
